__turbopack_context__.v({
  "edgePromo": "PortfolioHeader-module__kLfVea__edgePromo",
  "portfolioTitle": "PortfolioHeader-module__kLfVea__portfolioTitle",
  "shareIcons": "PortfolioHeader-module__kLfVea__shareIcons",
  "socialShare": "PortfolioHeader-module__kLfVea__socialShare",
  "wrapper": "PortfolioHeader-module__kLfVea__wrapper",
});
